interface CustomModal {
  imgLink?: string;
  header?: string;
  subHeader?: string;
  btn?: {
    content: string;
    level: string;
    link: string;
    icon?: string;
  };
  footerDescription?: string;
  footerOptions?: Array<{ label: string; link: string; icon?: any }>;
}
export interface ConfirmationModalConfig {
  header?: string;
  body?: string;
  HTMLBody?: string;
  cancel?: string;
  confirm?: string;
  altBackDropClass?: string;
  customModal?: CustomModal;
}
